import { ExpandIcon } from 'shared/icons/ExpandIcon'
import styles from './ExpandButton.module.css'

interface ExpandButtonProps{
    onClick: (event: any) => void
}

export const ExpandButton = (props: ExpandButtonProps) => {
    const {
        onClick
    } = props

    const handleExpandButtonClick = (event: any) => {
        onClick?.(event)
    }

    return (
        <button 
            className={styles.ExpandButton}
            onClick={handleExpandButtonClick}
        >
            <span  className={styles.ExpandButton__IconContainer}>
                <ExpandIcon 
                    className={styles.ExpandButton__Icon}
                />
            </span>
        </button>
    )
}